const locale = document.documentElement.lang.toLowerCase();
let actualLang = 'en';
let actualLocale = 'en';

if (['ja', 'jp'].includes(locale)) {
	actualLang = 'ja';
	actualLocale = 'jp';
} else if (['zh', 'zh-tw', 'cn-tw', 'cn'].includes(locale)) {
	actualLang = 'zh';
	actualLocale = 'cn';
}

/**
 * The current language being presented in the app
 * @type {string}
 */
export const LANGUAGE = actualLang;

/**
 * The current locale being presented in the app
 * @type {string}
 */
export const LOCALE = actualLocale;
